import './styles.css';

import React from 'react';
import { Button, ButtonProps } from '@vtblife/uikit';

import classname from '@search/classname/src';

const cn = classname.bind(null, 'Phone');

interface IProps extends ButtonProps {
    className?: string;
    phoneHref?: string;
    phoneFormatted?: string;
    error?: boolean;
}

export function Phone({
    phoneHref,
    phoneFormatted,
    error,
    onClick,
    className,
    fullWidth = true,
    ...buttonProps
}: IProps) {
    const button = (
        <Button
            fullWidth={fullWidth}
            {...buttonProps}
        >
            {error ? 'Ошибка' : phoneFormatted ?? 'Показать телефон'}
        </Button>
    );

    return (<>
        {phoneHref && (
            <a onClick={onClick} href={phoneHref} className={cn(null, { fullWidth }, className)}>
                {button}
            </a>
        )}
        {! phoneHref && (
            <div onClick={onClick} className={cn(null, { fullWidth }, className)}>
                {button}
            </div>
        )}
    </>);
}
